import queryString from 'query-string'

import { getCompaniesFilename, getCompaniesSearchBody } from 'models/company-model'
import { URL_API } from 'utils/envHelper'
import { downloadFileFromPayload } from 'utils/file'

// The export endpoint returns a CSV body, so use fetch + res.text() (utils/http does res.json(), which would fail on CSV).
export const exportCompanies = async (meta: any, format = 'csv') => {
  const query = queryString.stringify({ limit: meta.rowsPerPage, offset: meta.page * meta.rowsPerPage })

  const res = await fetch(`${URL_API}/management/companies/export/${format}?${query}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(getCompaniesSearchBody(meta)),
  })

  // Guard so a 4xx/5xx error body isn't downloaded as the CSV.
  if (!res.ok) throw res

  const payload = await res.text()

  downloadFileFromPayload(payload, getCompaniesFilename(meta.filters))
}
